export const environment = {
    production: false,
    apiUrl: "http://localhost:8080",
    tabscannerApiUrl: "https://api.tabscanner.com/api/2",
    tabscannerApiKey: "md_dejJgP-l1o8ceRqgbKCTZAPEXI12utcaFVQ2h7wHwv8",
    firebaseConfig: {
        apiKey: "AIzaSyDJ55CpgnOdyAea88plMfxjPz8ewCOBXd8",
        authDomain: "twogetherflower-8456b.firebaseapp.com",
        projectId: "twogetherflower-8456b",
        storageBucket: "twogetherflower-8456b.firebasestorage.app",
        messagingSenderId: "675743533214",
        appId: "1:675743533214:web:dd6891aa4db1eee047538f",
        measurementId: "G-F2753BEG43"
      }
  };
